import React from "react"
import { Box, Grid, Typography } from "@mui/material"
import { AppSitesAutocomplete } from "@components"
import { useComputed } from "@preact/signals-react"
import { useLocation } from "react-router-dom"
import { reportListMultipleData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_SITE_FILTERS } from "Pages/ReportsAlerts/Reports/@constants"
import { BACKEND_APIS, REPORT_ROUTES } from "@constants"
import { FlagsIconSeeker } from "@ui-seeker/core"
import { useReportMultipleModalMultipleEdit } from "Pages/ReportsAlerts/Reports/@hooks/multipleModalActions"


export default function ReportMultiModalSiteSection() {

	const { data, setData } = useReportMultipleModalMultipleEdit()
	const siteFilters = REPORT_TYPE_SITE_FILTERS[selectedReportTypeTab.value]
	const { pathname } = useLocation()
	const isExtra = pathname === REPORT_ROUTES.EXTRA_PATH
	const siteUrl = isExtra ? `${BACKEND_APIS.MASTER_DATA}/options/site-extras` : undefined

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Typography variant="h5">Edit Multiple Sites:</Typography>
		</Grid>
		<Grid item xs={6}>
			<AppSitesAutocomplete
				value={data}
				onChange={e => setData(e.target.value)}
				{...(siteUrl && { urlAjax: siteUrl })}
				{...(siteFilters && { filters: siteFilters })}
			/>
		</Grid>
		<Grid item xs={12}>
			<ReportMultiModalSiteDetails/>
		</Grid>
	</Grid>
}

function ReportMultiModalSiteDetails() {

	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Typography variant="subtitle2">Affected reports:</Typography>
		</Grid>
		<Grid item xs={12} sx={{ maxWidth: "800px", overflowX: "auto", pb: 2 }}>
			<Grid container spacing={2}>
				{reportsInfo.value.map(({ name, sitesName }, idx) => {
					return <Grid
						item
						xs={12}
						key={`${name}-${idx}`}
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "start",
							gap: 1,
						}}>
						<Typography variant="subtitle2" color="secondary.light">{name}:</Typography>
						{sitesName.map(({ name, market }, idx) => <Box
							key={`${name}-${idx}`}
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "start",
								gap: 1
							}}>
							<FlagsIconSeeker countryName={market}/>
							<Typography variant="caption">{name}</Typography>
						</Box>)}
					</Grid>
				})}
			</Grid>
		</Grid>
	</Grid>
}